import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './JobApplication.css';

export default function JobApplication({ onClose, jobTitle }) {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    address: '',
    resume: null,
    countryofresidence: 'United States of America',
    city: '',
    state: '',
  });
  const [submitting, setSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e) => {
    setFormData(prev => ({ ...prev, resume: e.target.files[0] }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (submitting) return;
    setSubmitting(true);

    const fd = new FormData();
    Object.entries(formData).forEach(([key, value]) => {
      if (value !== null && value !== undefined) fd.append(key, value);
    });
    fd.append('jobTitle', jobTitle || 'Unknown');

    try {
      const res = await fetch('/.netlify/functions/apply', {
        method: 'POST',
        body: fd,
      });
      const json = await res.json();
      if (!res.ok || !json.ok) throw new Error(json.error || 'Submit failed');

      onClose?.();

      navigate('/apply/success', { state: { jobTitle } });
    } catch (err) {
      console.error(err);
      alert('There was a problem submitting your application.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="job-app-modal" role="dialog" aria-modal="true">
      <div className="job-app-overlay" onClick={onClose} />
      <div className="job-app-content">
        <button className="close-btn" type="button" onClick={onClose}>×</button>
        <h2>Apply for {jobTitle}</h2>

        <form onSubmit={handleSubmit} className="job-app-form">
          <div className="form-group">
            <label htmlFor="firstName">First Name</label>
            <input id="firstName" name="firstName" type="text"
                   value={formData.firstName} onChange={handleChange} required />
          </div>

          <div className="form-group">
            <label htmlFor="lastName">Last Name</label>
            <input id="lastName" name="lastName" type="text"
                   value={formData.lastName} onChange={handleChange} required />
          </div>

          <div className="form-group">
            <label htmlFor="email">Email Address</label>
            <input id="email" name="email" type="email"
                   value={formData.email} onChange={handleChange} required />
          </div>

          <div className="form-group">
            <label htmlFor="phone">Phone</label>
            <input id="phone" name="phone" type="tel"
                   value={formData.phone} onChange={handleChange} />
          </div>

          <div className="form-group">
            <label htmlFor="resume">Resume</label>
            <input id="resume" name="resume" type="file"
                   accept=".pdf,.doc,.docx" onChange={handleFileChange} required />
          </div>

          <div className="form-group">
            <label htmlFor="countryofresidence">Country of Residence</label>
            <input id="countryofresidence" name="countryofresidence" type="text"
                   value={formData.countryofresidence} onChange={handleChange} />
          </div>

          <div className="form-group">
            <label htmlFor="address">Address</label>
            <input id="address" name="address" type="text"
                   value={formData.address} onChange={handleChange} />
          </div>

          <div className="form-group">
            <label htmlFor="city">City</label>
            <input id="city" name="city" type="text"
                   value={formData.city} onChange={handleChange} />
          </div>

          <div className="form-group">
            <label htmlFor="state">State</label>
            <input id="state" name="state" type="text"
                   value={formData.state} onChange={handleChange} />
          </div>

          <button type="submit" className="submit-btn" disabled={submitting}>
            {submitting ? 'Submitting…' : 'Submit Application'}
          </button>
        </form>
      </div>
    </div>
  );
}
